import { getCookieValue } from 'root/cookie';

const cookieName: string = 'show_announcement';
const cookieLifetimeInDays: number = 7;

function setCookie(name: string, value: string, daysUntilExpires: number): void {
  const expirationDate = new Date();
  expirationDate.setTime(expirationDate.getTime() + daysUntilExpires * 24 * 60 * 60 * 1000);
  const expires = `expires=${expirationDate.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
}

// close the announcement for 7 days
function closeAnnouncment(): void {
  setCookie(cookieName, 'false', cookieLifetimeInDays);
  document.getElementById('announcement')?.remove();
}

// check if the cookie is set, and if cookie exists don't show announcement
function shouldShow(): boolean {
  return !!(getCookieValue(cookieName) !== 'false');
}

function init(): void {
  const showAnnouncement = shouldShow();
  if (showAnnouncement) {
    document.getElementById('announcement')?.classList.remove('hidden');
    document.getElementById('announcement-close')?.addEventListener('click', closeAnnouncment);
  } else {
    document.getElementById('announcement')?.remove();
  }
}

// Using jQuery here to leverage it's backwards compatibility with the variety of document ready states
$('document').ready(() => {
  init();
});
